import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { FlashcardReviewItem, FlashcardReviewState } from './types';

const initialState: FlashcardReviewState = {
  dueCards: [],
  allCards: [],
  isLoading: false,
  sessionIndex: 0,
  sessionComplete: false,
  searchTerm: ''
};

export const slice = createSlice({
  name: 'flashcardReview',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    setDueCards(state, action: PayloadAction<FlashcardReviewItem[]>) {
      state.dueCards = action.payload;
    },
    setAllCards(state, action: PayloadAction<FlashcardReviewItem[]>) {
      state.allCards = action.payload;
    },
    setSearchTerm(state, action: PayloadAction<string>) {
      state.searchTerm = action.payload;
    },
    advanceCard(state) {
      if (state.sessionIndex >= state.dueCards.length - 1) {
        state.sessionComplete = true;
      }
      state.sessionIndex += 1;
    },
    resetSession(state) {
      state.sessionIndex = 0;
      state.sessionComplete = false;
    },
    updateCard(state, action: PayloadAction<FlashcardReviewItem>) {
      const updated = action.payload;
      const allIdx = state.allCards.findIndex((c) => c.guid === updated.guid);
      if (allIdx !== -1) state.allCards[allIdx] = updated;
      const dueIdx = state.dueCards.findIndex((c) => c.guid === updated.guid);
      if (dueIdx !== -1) state.dueCards[dueIdx] = updated;
    },
    removeCard(state, action: PayloadAction<string>) {
      state.allCards = state.allCards.filter((c) => c.guid !== action.payload);
      state.dueCards = state.dueCards.filter((c) => c.guid !== action.payload);
    }
  }
});

export default slice.reducer;
